import { createSelector } from '@reduxjs/toolkit';

import { InAppChatState } from './reducer';

const selectState = (state: any) => state.services.inAppChat as InAppChatState;

export const selectSupportChatStatus = createSelector(selectState, (state) => state.supportChatStatus);
